import React from 'react'
import { compose } from 'recompose'
import { makeStyles } from '@material-ui/core/styles'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { Container, Grid } from '@material-ui/core'
import SurveyResponseListItem from './SurveyResponseListItem'
import emptyIcon from '../../../../assets/images/empty-documents.svg'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	rootChart: {
		width: '100%',
		color: '#000',
		fontSize: '1.2em',
		paddingBottom: '42px',
		display: 'block',
		position: 'relative',
	},
	rootEmpty: {
		flexGrow: 1,
		color: '#000',
		fontSize: '1.2em',
        minHeight: 'calc(100vh - 84px - 55px)',
		textAlign: 'center',
		[theme.breakpoints.down('sm')]: {
			minHeight: 'calc(100vh - 61px - 55px)',
            maxHeight: 'calc(100vh - 61px - 55px)',
        }
	},
}))

const SurveyResponseList = ({ schema, benchmarcs, hasScoringGroups, intl }) => {
	const classes = useStyles()

	return (
		<div>
            {schema && schema.length > 0
				?
				schema.map((item, index) =>
                    <Grid
                        className={clsx(classes.rootChart, `rootChart`)}
                        container direction='column' alignItems='center'>
						<SurveyResponseListItem item={item} key={index} benchmarcs={benchmarcs && benchmarcs.find(x => x.scoringGroupId === item.scoringGroupId && x.showBenchmarc)}/>
					</Grid>
					)
				:
				(
				<Grid className={classes.rootEmpty} container direction='column' alignItems='center'>
					<img alt="Empty Icon" src={emptyIcon} style={{ margin: '50px 0 30px'}}></img>
					<Typography
						data-testid="survey-response-results-label"
						variant='h2'
						style={{ color: '#000', fontSize: '26px', margin: '0 0 30px 0' }}>
						{hasScoringGroups ? intl.formatMessage({ id: 'app.scores.empty' }) : intl.formatMessage({ id: 'app.scores.noScoringGroups' })}
					</Typography>
				</Grid>
				)
			}
        </div>
	)
}

const enhance = compose(injectIntl)

export default enhance(SurveyResponseList)
